import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t border-glass py-8 bg-white/80 backdrop-blur-md">
      <div className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded bg-gradient-to-tr from-primary to-secondary flex items-center justify-center font-bold text-white text-xs">
            A
          </div>
          <span className="text-sm font-semibold tracking-tight text-main">
            Acczite Simulations
          </span>
        </div>
        <p className="text-xs text-muted-text">
          &copy; {new Date().getFullYear()} Acczite. All rights reserved. Mimicking acczite.com visual branding.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
